<template>
  <div class="mt-40">
    <div
      class="flex justify-between fixed bottom-0 left-0 bg-indigo-700 py-2 px-2 border-t w-full"
    >
      <label class="block">
        <select
          :value="entriesPerPage"
          class="form-select bg-indigo-600 border hover:bg-indigo-500 border-indigo-500 text-white block w-full"
          @change="changeLimit(Number($event.target.value))"
        >
          <option>50</option>
          <option>100</option>
          <option>500</option>
          <option value="9999">500+</option>
        </select>
      </label>
      <div class="flex items-center">
        <span v-if="checkedEntries.length" class="mr-4 text-orange-400">{{
          checkedEntriesLabel
        }}</span>
        <span class="mr-4 text-white">{{ pageItemsCount }} </span>
        <ul class="flex">
          <li
            class="page-item bg-indigo-600 border-r-0 rounded-l hover:bg-indigo-500"
          >
            <button
              class="page-button"
              :disabled="firstPage"
              @click="gotoPage(1)"
            >
              Primero
            </button>
          </li>
          <li class="page-item bg-indigo-600 border-r-0 hover:bg-indigo-500">
            <button
              class="page-button"
              :disabled="firstPage"
              @click="gotoPage(currentPage - 1)"
            >
              Previo
            </button>
          </li>
          <li
            v-for="page in pages"
            :key="page.name"
            :class="[isActive(page.name) ? 'bg-indigo-500' : 'bg-indigo-600']"
            class="page-item border-r-0 hover:bg-indigo-500"
          >
            <button
              class="page-button"
              :class="{ 'font-bold': isActive(page.name) }"
              :disabled="page.disabled"
              @click="gotoPage(page.name)"
            >
              {{ page.name }}
            </button>
          </li>
          <li class="page-item bg-indigo-600 hover:bg-indigo-500">
            <button
              class="page-button"
              :disabled="lastPage"
              @click="gotoPage(currentPage + 1)"
            >
              Siguiente
            </button>
          </li>
          <li class="page-item bg-indigo-600 rounded-r hover:bg-indigo-500">
            <button
              class="page-button"
              :disabled="lastPage"
              @click="gotoPage(numPages)"
            >
              Último
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState(["currentPage", "entriesPerPage", "checkedEntries"]),
    ...mapGetters(["currentTab", "numPages", "firstPage", "lastPage", "pages"]),
    pageItemsCount() {
      const total = this.currentTab.totalLength;
      const first = (this.currentPage - 1) * this.entriesPerPage + 1;
      const last = Math.min(
        (this.currentPage - 1) * this.entriesPerPage + this.entriesPerPage,
        total
      );
      return `${first}-${last} de ${total}`;
    },
    checkedEntriesLabel() {
      return this.checkedEntries.length === 1
        ? "1 entrada seleccionada"
        : `${this.checkedEntries.length} entradas seleccionadas`;
    },
  },
  methods: {
    ...mapActions(["changeLimit", "gotoPage"]),
    isActive(page) {
      return this.currentPage === page;
    },
  },
};
</script>

<style>
.page-item {
  @apply leading-tight border border-indigo-500 text-white;
}

.page-button {
  @apply px-3 py-2;
}
</style>
